import { render, staticRenderFns } from "./outpatientVisitRegionPage.vue?vue&type=template&id=257d6bc4&scoped=true&"
import script from "./outpatientVisitRegionPage.vue?vue&type=script&lang=js&"
export * from "./outpatientVisitRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./outpatientVisitRegionPage.vue?vue&type=style&index=0&id=257d6bc4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d6bc4",
  null
  
)

export default component.exports